export class CreateMagazineDTO {
  constructor(magazine) {
    this.name = magazine.name;
    this.description = magazine.description;
    this.department = magazine.department;
  }

  createEmpty() {
    return new CreateMagazineDTO({ name: '', description: '', department: '' });
  }
}

export class UpdateMagazineDTO extends CreateMagazineDTO {
  constructor(magazine) {
    super(magazine)
    this.id = magazine.id
    this.image = magazine.image
    this.department = magazine.department?.id || null
  }
}